import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { goToNextInput } from '../util/utils';

/**
 * Resolve nome do médico pelo código no Enter e avança o foco.
 * Usado nos modais de faturamento (create/edit).
 */
const useGetNomeMedico = (medicos, setFatura) =>
  useCallback(
    (e, nextInput, fieldName) => {
      if (e.key !== 'Enter') return;

      const inputValue = Number(e.target.value);
      const med = medicos.find(d => d.CODMEDICO === inputValue);
      if (med) {
        setFatura(prevFatura => ({
          ...prevFatura,
          [fieldName]: med.NOMEMED,
        }));
        goToNextInput(e, nextInput);
        return;
      }

      toast.error('Médico não localizado!');
      goToNextInput(e, e.target.name);
    },
    [medicos, setFatura]
  );

export default useGetNomeMedico;
